import './wizard.scss';
import 'mdn-polyfills/Element.prototype.closest';
import uniqueId from 'lodash/uniqueId';

// Copied from form.js
// Properly size notch of initially hidden fields
function initVisibleFields(root) {
	root.querySelectorAll('.mdc-text-field').forEach(textField => {
		const notchedOutline = textField.querySelector('.mdc-notched-outline--notched');

		if (notchedOutline && textField.MDCTextField) {
			textField.MDCTextField.foundation_.notchOutline(true);
		}
	});
}

/**
 * Legacy component
 */
function Wizard(element) {
	this.ui = {
		element: element
	};

	this.settings = {
		domSelectors: {
			wrapper: '[data-wizard="wrapper"]',
			step: '[data-wizard="step"]',
			info: '[data-wizard="info"]',
			infoWrapper: '[data-wizard="infoWrapper"]',
			prev: '[data-wizard="prev"]',
			next: '[data-wizard="next"]'
		},
		stateClasses: {
			isActive: 'is-active',
			isDone: 'is-done',
			isVisible: 'is-visible',
			isError: 'is-error'
		},
		bottomPadding: 80
	};

	this.init();
}

Wizard.prototype.init = function () {
	var initialStep = 0,
		initialUrlStep = this._getStepFromUrl();

	this.wrapper = this.ui.element.querySelector(this.settings.domSelectors.wrapper);
	this.steps = Array.prototype.slice.call(
		this.ui.element.querySelectorAll(this.settings.domSelectors.step)
	);

	if (!this.wrapper || this.steps.length === 0) {
		return;
	}

	this.navNext = Array.prototype.slice.call(
		this.ui.element.querySelectorAll(this.settings.domSelectors.next)
	);
	this.navPrev = Array.prototype.slice.call(
		this.ui.element.querySelectorAll(this.settings.domSelectors.prev)
	);

	// Set height
	this.setMinHeight();

	setTimeout(() => {
		this.setMinHeight();
	}, 1000);

	// Handle prev/next links
	this.navNext.forEach(element => {
		element.addEventListener('click', event => {
			event.preventDefault();

			this.next();
		});
	});

	this.navPrev.forEach(element => {
		element.addEventListener('click', event => {
			event.preventDefault();

			this.prev();
		});
	});

	// Active initial element
	if (initialUrlStep !== undefined) {
		this.activate(initialUrlStep);
	} else {
		this.steps.forEach((step, i) => {
			if (step.classList.contains(this.settings.stateClasses.isActive)) {
				initialStep = i;
			}
		});

		this.activate(initialStep);
	}

	// Handle hashchange event
	window.addEventListener('hashchange', () => {
		var targetStep = this._getStepFromUrl();

		if (targetStep !== undefined) {
			this.activate(targetStep);
		}
	});
};

Wizard.prototype.activate = function (targetStep) {
	var targetElement = this.steps[targetStep],
		activeElement = this.steps[this.activeStep || 0];

	if (!targetElement || (this.activeStep !== undefined && this.activeStep === targetStep)) {
		return;
	}

	// Remove existing messages
	this.resetMessage();

	// Remove active class from active element
	activeElement.classList.remove(this.settings.stateClasses.isActive);

	if (targetStep > this.activeStep) {
		// Move active to the left
		activeElement.classList.add(this.settings.stateClasses.isDone);
	} else {
		// Move active element to the right
		targetElement.classList.remove(this.settings.stateClasses.isDone);
	}

	// Show target element
	targetElement.classList.add(this.settings.stateClasses.isActive);

	// Scroll to top
	window.scrollTo({ top: 0, behavior: 'smooth' });

	// Save new active element
	this.activeStep = targetStep;

	// Enable form fields
	initVisibleFields(targetElement);

	// Update URL
	window.location.hash = targetStep > 0 ? '#step' + (targetStep + 1) : '';
};

Wizard.prototype.next = function () {
	var targetStep = this.activeStep + 1;

	this.activate(targetStep);
};

Wizard.prototype.prev = function () {
	var targetStep = this.activeStep - 1;

	this.activate(targetStep);
};

Wizard.prototype.setMinHeight = function () {
	var minHeight = 0;

	this.steps.forEach(step => {
		var height = step.offsetHeight;

		if (height > minHeight) {
			minHeight = height;
		}
	});

	minHeight += this.settings.bottomPadding;

	this.wrapper.style.minHeight = minHeight + 'px';
};

Wizard.prototype.showMessage = function (options = {}) {
	var info = this.steps[this.activeStep || 0].querySelector(this.settings.domSelectors.info);
	var infoWrapper = this.steps[this.activeStep || 0].querySelector(
		this.settings.domSelectors.infoWrapper
	);

	if (!info) {
		return;
	}

	info.innerHTML = options.message || '';
	info.classList.add(this.settings.stateClasses.isVisible);

	if (infoWrapper) {
		if (options.error) {
			infoWrapper.classList.add(this.settings.stateClasses.isError);
		} else {
			infoWrapper.classList.remove(this.settings.stateClasses.isError);
		}
	}

	window.scrollTo({ top: 0, behavior: 'smooth' });
};

Wizard.prototype.resetMessage = function () {
	var info = this.steps[this.activeStep || 0].querySelector(this.settings.domSelectors.info);

	if (!info) {
		return;
	}

	info.innerHTML = '';
	info.classList.remove(this.settings.stateClasses.isVisible);
};

Wizard.prototype._getStepFromUrl = function () {
	var urlHash = window.location.hash.replace(/#step/, ''),
		targetStep = 0;

	if (urlHash) {
		targetStep = parseInt(urlHash, 10) - 1;
	}

	return isNaN(targetStep) ? 0 : targetStep;
};

document.querySelectorAll('[data-init~="wizard"]').forEach(element => {
	const instanceId = (element.dataset.wizard = uniqueId('wizard'));
	const instance = new Wizard(element);

	window.moduleInstances = window.moduleInstances || {};
	window.moduleInstances[instanceId] = instance;
});
